/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import _ from 'lodash';
import InputMask from "react-input-mask";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import UserCompanyProfileValidator from "../../../helpers/validators/UserCompanyProfileValidator";
import { getInputClasses, convertJsonToFormData } from "../../../helpers/helper";
import * as userService from "../../../services/management/userService";
import * as alert from "../../../redux/alertSnackBarRedux";
import * as userProfile from "../../../redux/userProfileOverviewRedux";
import { Button, Modal } from "react-bootstrap";

function AccountInformation(props) {
  const { userProfileState, showAlert, updateUserProfile, auth, history } = props;
  const [loading, setloading] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [initialValues, setInitialValues] = useState({
    isActive: false,
    ssn: '',
    hourlyRate: '',
    roles: '',
    twicPin: '',
    payloadMultiplier: '',
    safetyCouncilStudentId: '',
    driverLicenseNumber: '',
    disaId: '',
    aiId: '',
  });
  const adminCheckbox = useRef();
  const projectManagerCheckbox = useRef();
  const technicianCheckbox = useRef();
  const workerCheckbox = useRef();
  const isActiveCheckboxRef = useRef();

  useEffect(() => {
    if (userProfileState.id) {
      setForm();
    }
  }, [userProfileState]);

  const setForm = () => {
    userService.getUserCompanyInfo(userProfileState.id).then(res => {
      setInitialValues(res);
      SetUpCheckBox();
      isActiveCheckboxRef.current.checked = res.isActive;
    })
  }

  const SetUpCheckBox = () => {
    var userInRoles = [];
    userProfileState.roles.split(",").forEach(x => {
      userInRoles.push(x.trim());
      switch (x.toUpperCase().trim()) {
        case "ADMIN":
          adminCheckbox.current.checked = true;
          break;
        case "PROJECT MANAGER":
          projectManagerCheckbox.current.checked = true;
          break;
        case "TECHNICIAN":
          technicianCheckbox.current.checked = true;
          break;
        case "WORKER":
          workerCheckbox.current.checked = true;
          break;
        default:
      }

    });

    setSelectedRoles(userInRoles);
  }

  // Methods
  const saveUser = (values, setStatus, setSubmitting) => {
    if (selectedRoles.length > 0) {
      setloading(true);
      setSubmitting(true);
      userService.updateCompanyInformation({ ...values, id: userProfileState.id, roles: selectedRoles.join(',') }).then(res => {
        showAlert({ message: res.message, variant: "success" });
      }).catch(ex => {
        showAlert({ message: ex.message, variant: "error" });
      }).finally(() => {
        setloading(false);
        setSubmitting(false);
      })
      return;
    }

    setSubmitting(false);
    showAlert({ message: "Please select at least one role to be assigned to this user", variant: "warning" })
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: UserCompanyProfileValidator,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      saveUser(values, setStatus, setSubmitting);
    }
  });

  const handleRoleChange = (e) => {
    var selectedRolesCopy = [...selectedRoles];
    if (e.target.checked) {
      selectedRolesCopy.push(e.target.name);
    } else {
      _.pull(selectedRolesCopy, e.target.name);
    }

    setSelectedRoles(selectedRolesCopy);
  }

  return (
    <>
      <form className="card card-custom" onSubmit={formik.handleSubmit}>
        {loading && <ModalProgressBar />}
        <div className="card-header py-3">
          <div className="card-title align-items-start flex-column">
            <h3 className="card-label font-weight-bolder text-dark">
              Company Information
          </h3>
            <span className="text-muted font-weight-bold fz-xs mt-1">
              Update company information
          </span>
          </div>
          {
            auth.isAdmin ?
              <div className="card-toolbar">
                <button
                  type="submit"
                  className="btn btn-success mr-2"
                  disabled={
                    formik.isSubmitting || (formik.touched && !formik.isValid)
                  }
                >
                  Save Changes {formik.isSubmitting}
                </button>
                <a
                  onClick={() => history.goBack()}
                  className="btn btn-danger"
                >
                  Cancel
                </a>
              </div>
              : <></>
          }
        </div>
        <div className="form">
          <div className="card-body">
            <div className="row">
              <label className="col-xl-3"></label>
              <div className="col-lg-9 col-xl-6">
                <h5 className="mb-6 fz-md fw-700 c-primary">Company Info</h5>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Role
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="checkbox-list">
                  <label className="checkbox checkbox-primary">
                    <input
                      type="checkbox"
                      disabled={!auth.isAdmin}
                      name="Admin"
                      ref={adminCheckbox}
                      onChange={handleRoleChange}
                    />
                    <span></span> Administrator
                </label>
                  <label className="checkbox checkbox-primary">
                    <input
                      type="checkbox"
                      disabled={!auth.isAdmin}
                      ref={projectManagerCheckbox}
                      name="Project Manager"
                      onChange={handleRoleChange}
                    />
                    <span></span> Project Manager
                </label>
                  <label className="checkbox checkbox-primary">
                    <input
                      type="checkbox"
                      disabled={!auth.isAdmin}
                      name="Technician"
                      ref={technicianCheckbox}
                      onChange={handleRoleChange}
                    />
                    <span></span> Technician
                </label>
                  <label className="checkbox checkbox-primary">
                    <input
                      type="checkbox"
                      disabled={!auth.isAdmin}
                      name="Worker"
                      ref={workerCheckbox}
                      onChange={handleRoleChange}
                    />
                    <span></span> Worker
                </label>
                </div>
              </div>
            </div>
            {
              auth.isAdmin ?
                <>
                  <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                      Hourly Rate
                    </label>
                    <div className="col-lg-9 col-xl-6">
                      <div className="input-group input-group-lg input-group-solid">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="fa fa-dollar-sign"></i>
                          </span>
                        </div>
                        <input
                          type="number"
                          disabled={!auth.isAdmin}
                          placeholder="14.99"
                          className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "hourlyRate")}`}
                          name="hourlyRate"
                          {...formik.getFieldProps("hourlyRate")}
                        />
                      </div>
                      {formik.touched.hourlyRate && formik.errors.hourlyRate ? (
                        <div className="invalid-feedback display-block">
                          {formik.errors.hourlyRate}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                      Payload Multiplier
                    </label>
                    <div className="col-lg-9 col-xl-6">
                      <div className="input-group input-group-lg input-group-solid">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="fa fa-times"></i>
                          </span>
                        </div>
                        <input
                          type="number"
                          disabled={!auth.isAdmin}
                          placeholder="0.00"
                          className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "payloadMultiplier")}`}
                          name="payloadMultiplier"
                          {...formik.getFieldProps("payloadMultiplier")}
                        />
                      </div>
                      {formik.touched.payloadMultiplier && formik.errors.payloadMultiplier ? (
                        <div className="invalid-feedback display-block">
                          {formik.errors.payloadMultiplier}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </>
                : <></>
            }
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                TWIC Pin#
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-hashtag"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={!auth.isAdmin}
                    placeholder="9985648"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "twicPin")}`}
                    name="twicPin"
                    {...formik.getFieldProps("twicPin")}
                  />
                </div>
                {formik.touched.twicPin && formik.errors.twicPin ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.twicPin}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Safety Council Student ID
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-id-badge"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={!auth.isAdmin}
                    placeholder="778564"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "safetyCouncilStudentId")}`}
                    name="safetyCouncilStudentId"
                    {...formik.getFieldProps("safetyCouncilStudentId")}
                  />
                </div>
                {formik.touched.safetyCouncilStudentId && formik.errors.safetyCouncilStudentId ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.safetyCouncilStudentId}
                  </div>
                ) : null}
              </div>
            </div>
            
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                DISA ID #
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-id-card-alt"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={!auth.isAdmin}
                    placeholder="001234"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "disaId")}`}
                    name="disaId"
                    {...formik.getFieldProps("disaId")}
                  />
                </div>
                {formik.touched.disaId && formik.errors.disaId ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.disaId}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                AI #
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-hashtag"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={!auth.isAdmin}
                    placeholder="0012345"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "aiId")}`}
                    name="aiId"
                    {...formik.getFieldProps("aiId")}
                  />
                </div>
                {formik.touched.aiId && formik.errors.aiId ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.aiId}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Is Active?
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="checkbox-list">
                  <label className="checkbox checkbox-primary">
                    <input
                      type="checkbox"
                      disabled={!auth.isAdmin}
                      name="admin"
                      ref={isActiveCheckboxRef}
                      {...formik.getFieldProps("isActive")}
                    />
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </>
  );
}

const mapStateToProps = (state) => ({
  userProfileState: state.userProfile,
  auth: state.auth
});


export default connect(mapStateToProps, {
  ...userProfile.actions,
  ...alert.actions
})(AccountInformation);
